import { render, staticRenderFns } from "./ItemHighlight.vue?vue&type=template&id=00ad86b9&scoped=true"
import script from "./ItemHighlight.vue?vue&type=script&lang=js"
export * from "./ItemHighlight.vue?vue&type=script&lang=js"
import style0 from "./ItemHighlight.vue?vue&type=style&index=0&id=00ad86b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ad86b9",
  null
  
)

export default component.exports